/**
 * CPF e CNPJ na UI: máscara enquanto digita e dígitos verificadores. Espelha apps/client-api/src/br-documents.js — a UI só poupa uma
 * ida ao servidor; quem decide é o servidor. Não consulta a Receita.
 */
const onlyDigits = (v: string) => v.replace(/\D/g, '');

/** `000.000.000-00`, aplicada aos dígitos já digitados (até 11). */
export function maskCpf(v: string): string {
  const d = onlyDigits(v).slice(0, 11);
  return d.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
}

/** `00.000.000/0000-00`, aplicada aos dígitos já digitados (até 14). */
export function maskCnpj(v: string): string {
  const d = onlyDigits(v).slice(0, 14);
  return d.replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4').replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, '$1.$2.$3/$4-$5');
}

function check(d: string, weights: number[]): number {
  const rest = weights.reduce((acc, w, i) => acc + Number(d[i]) * w, 0) % 11;
  return rest < 2 ? 0 : 11 - rest;
}

const valid = (v: string, len: number, w1: number[], w2: number[]): boolean => {
  const d = onlyDigits(v);
  if (d.length !== len || /^(\d)\1+$/.test(d)) return false;
  return check(d, w1) === Number(d[len - 2]) && check(d, w2) === Number(d[len - 1]);
};

export const isCpf = (v: string) => valid(v, 11, [10, 9, 8, 7, 6, 5, 4, 3, 2], [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
export const isCnpj = (v: string) => valid(v, 14, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2], [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
